// @ts-nocheck
export const localeCodes =  [
  "en",
  "de"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_6a832505",
      load: () => import("#nuxt-i18n/6a832505" /* webpackChunkName: "locale_en_46json_6a832505" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_4f0b1ce4",
      load: () => import("#nuxt-i18n/4f0b1ce4" /* webpackChunkName: "locale_de_46json_4f0b1ce4" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    name: "English"
  },
  {
    code: "de",
    language: "de-DE",
    name: "Deutsch"
  }
]
/** client **/

/** client-end **/